import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { Router } from "@angular/router";
import {
  InvocationListItem,
  PaginationInfo,
} from "../../models/invocation.models";

// Re-export for components that import from this file
export {
  InvocationListItem,
  PaginationInfo,
} from "../../models/invocation.models";

@Component({
  selector: "app-invocations-table",
  standalone: false,
  templateUrl: "./invocations-table.component.html",
  styleUrls: ["./invocations-table.component.scss"],
})
export class InvocationsTableComponent implements OnChanges {
  @Input() invocations: InvocationListItem[] = [];
  @Input() pagination: PaginationInfo | null = null;
  @Input() loading = false;
  @Input() sortBy = "createdAt";
  @Input() sortDirection: "asc" | "desc" = "desc";

  @Output() pageChange = new EventEmitter<{
    pageIndex: number;
    pageSize: number;
  }>();
  @Output() sortChange = new EventEmitter<{
    active: string;
    direction: string;
  }>();

  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  displayedColumns: string[] = [
    "createdAt",
    "phoneNumber",
    "result",
    "billingEntityId",
    "agentId",
    "durationMs",
  ];

  dataSource = new MatTableDataSource<InvocationListItem>([]);

  constructor(private router: Router) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["invocations"]) {
      this.dataSource.data = this.invocations;
    }
  }

  onPageChange(event: PageEvent): void {
    this.pageChange.emit({
      pageIndex: event.pageIndex,
      pageSize: event.pageSize,
    });
  }

  onSortChange(sort: Sort): void {
    this.sortChange.emit({
      active: sort.active,
      direction: sort.direction,
    });
  }

  onRowClick(row: InvocationListItem): void {
    this.router.navigate(["/invocations", row.invocationId]);
  }

  getStatusClass(status: string | null): string {
    if (!status) return "status-unknown";
    const statusMap: Record<string, string> = {
      completed: "status-completed",
      in_progress: "status-in-progress",
      failed: "status-failed",
      pending: "status-pending",
    };
    return statusMap[status] || "status-unknown";
  }

  getResultClass(result: string | null): string {
    if (!result) return "result-unknown";
    const resultMap: Record<string, string> = {
      answered: "result-answered",
      no_answer: "result-no-answer",
      voicemail: "result-voicemail",
      error: "result-error",
    };
    return resultMap[result] || "result-unknown";
  }

  formatResult(result: string | null): string {
    if (!result) return "Unknown";
    const resultLabels: Record<string, string> = {
      answered: "Answered",
      no_answer: "No Answer",
      voicemail: "Voicemail",
      error: "Error",
    };
    return resultLabels[result] || result;
  }

  formatStatus(status: string | null): string {
    if (!status) return "Unknown";
    const statusLabels: Record<string, string> = {
      completed: "Completed",
      in_progress: "In Progress",
      failed: "Failed",
      pending: "Pending",
    };
    return statusLabels[status] || status;
  }
}
